// src/context/FeedbackContext.js

import { createContext } from "react";

const FeedbackContext = createContext({
  feedbackCount: 0,
  setFeedbackCount: () => {},
});

export default FeedbackContext;
